import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext.js';
import { useAuthStore } from '../state/authStore.js';

export function LoginPage() {
  const { t } = useI18n();
  const status = useAuthStore((s) => s.status);
  const error = useAuthStore((s) => s.error);
  const login = useAuthStore((s) => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (status === 'authenticated') return <Navigate to="/products" replace />;

  return (
    <div
      style={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--surface-sunken)',
      }}
    >
      <form
        className="card"
        style={{ width: 360, display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
        onSubmit={async (e) => {
          e.preventDefault();
          setSubmitting(true);
          await login(email, password);
          setSubmitting(false);
        }}
      >
        <h1 style={{ fontSize: 'var(--text-xl)', fontWeight: 'var(--weight-bold)' }}>{t('login.title')}</h1>

        {error === 'invalid_credentials' && <p className="field-error">{t('login.error')}</p>}
        {error === 'network' && <p className="field-error">{t('login.networkError')}</p>}

        <label htmlFor="login-email">
          {t('login.email')}
          <input
            id="login-email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label htmlFor="login-password">
          {t('login.password')}
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        <button type="submit" className="btn btn--primary" disabled={submitting}>
          {submitting ? t('login.submitting') : t('login.submit')}
        </button>
      </form>
      {/* Discreet: the terminal app normally arrives via provisioning and
          self-update; this link exists for setting up a brand-new device
          from zero. /app/download/latest 302s to the current channel APK. */}
      <a
        href="/app/download/latest"
        className="field-hint"
        style={{ marginTop: 'var(--space-4)', textDecoration: 'underline' }}
      >
        {t('login.downloadApk')}
      </a>
    </div>
  );
}
